import { call, put, select } from 'redux-saga/effects';

import { fetchCitiesRequestSuccessful } from '../../redux/bookings/actions';
import { messagesShow } from '../../redux/messages/actions';
import BookingClient from '../../api/BookingClient';
import { isAuthenticateSelector } from '../../selectors/login';

export default function*() {
    try {
        const isUserAuthenticated = yield select(isAuthenticateSelector);

        // No explicit anonymous token fetch: the anonymous client gets its
        // token on demand, and its failures then reach the catch below.
        const allCities = yield call(BookingClient.getCities, isUserAuthenticated);

        yield put(fetchCitiesRequestSuccessful(allCities));
    } catch (error) {
        if (
            error &&
            error.code !== 500 &&
            error.message !== 'Unable to make HTTP request: error.response is undefined'
        ) {
            console.error('Error in fetchCitiesRequest', error);
            yield put(messagesShow('internalServerError', 'error'));
        }
    }
}
